class CustomAccountAddressesV2 {
  static #PROVINCE_DISTRICT_SEV_V2_LOCAL_STORAGE_KEY = 'province_district_sev_v2';
  static #NEW_PROVINCE_DISTRICT_SEV_LOCAL_STORAGE_KEY = 'province_district_sev_v2_new';
  static #PROVINCE_DISTRICT_CDN_URL = 'https://cdn.shopify.com/s/files/1/0650/1859/3459/files/province_district_sev_v2.json';
  static #NEW_PROVINCE_DISTRICT_CDN_URL = 'https://cdn.shopify.com/s/files/1/0650/1859/3459/files/new_province_district_sev.json';
  static #SESSION_STORAGE_TYPE = {
    get: 'get',
    set: 'set'
  };
  static #CITY_LABEL = "Thành phố";
  static #DISTRICT_LABEL = "Quận/Huyện";
  static #WARD_LABEL = "Phường/Xã";
  static #ADDRESS_SELECTION_TYPE = {
    beforeMerger: 'before-merger',
    afterMerger: 'after-merger'
  };
  static #DEFAULT_FORM_ADDRESS_ID = 'new';

  #provinceDistrictSev = null;
  #newProvinceDistrictSev = null;
  #selectedAddressType = {
    [CustomAccountAddressesV2.#DEFAULT_FORM_ADDRESS_ID]: CustomAccountAddressesV2.#ADDRESS_SELECTION_TYPE.beforeMerger
  };

  constructor () {
    this.router = new RouterRouter();
    this.#provinceDistrictSev = JSON.parse(this.#handleSession('get', CustomAccountAddressesV2.#PROVINCE_DISTRICT_SEV_V2_LOCAL_STORAGE_KEY));
    this.#newProvinceDistrictSev = JSON.parse(this.#handleSession('get', CustomAccountAddressesV2.#NEW_PROVINCE_DISTRICT_SEV_LOCAL_STORAGE_KEY));
  }

  initialize () {
    //js ACCOUNT
    router.route('account/*type', () => {
      this.#ensureDistrictIsFetched();
      this.#ensureNewAddressDataIsFetched();
    });

    router.route('account/addresses', () => {
      this.#initialEditAddress();
      this.#initialAddNewAddress();

      setTimeout(function () {
        if ($('.remodal-is-opened').length > 0) {
          $('.remodal-is-opened').click();
        }
      }, 500);
    });
  }

  /**
   * JS ACCOUNT ADDRESS -- call API get district
   */
  #ensureDistrictIsFetched () {
    if (!this.#provinceDistrictSev) {
      this.#getDistrict().then(data => {
        this.#provinceDistrictSev = data;
      });
    }
  }

  /**
   * JS ACCOUNT ADDRESS -- call API get new address data
   */
  #ensureNewAddressDataIsFetched () {
    if (!this.#newProvinceDistrictSev) {
      this.#getNewAddressData().then(data => {
        this.#newProvinceDistrictSev = data;
      });
    }
  }

  /**
   * JS ACCOUNT ADDRESS -- call API get district
   */
  #initialEditAddress () {
    $('p.customer-address').map((i, ele) => {
      $(ele).html($(ele).html().replace('00000', ''));
    });
    const $eleAddressActions = $('.js-address-actions');
    $eleAddressActions.find('.link').on('click', (event) => {
      const self = $(event.currentTarget);
      if (self.data('remodal-target') !== null) {
        const customerAddressesMetafield = window.customerAddressesList;
        const idEditAddress = self.data('remodal-target');
        const $frmAddress = $(`div[data-remodal-id="${idEditAddress}"]`).find('#form-address-validate');

        const addressId = $frmAddress.data('id');
        const selectedData = customerAddressesMetafield.find(addr => addr.id === String(addressId));

        if (selectedData) {
          $frmAddress.find('.js-address-form-data').attr('data-province', selectedData.province);
        }

        this.#handleSetupForm($frmAddress);
        this.#handleActiveProvince($frmAddress);
      }
    });
  }

  /**
   * JS ACCOUNT ADDRESS -- add new address
   */
  #initialAddNewAddress () {
    $('[data-remodal-target="new-address"]').on('click', () => {
      const $frmAddress = $('#address_form_new');

      this.#handleSetupForm($frmAddress);
      this.#handleShowOptionDistrictNewAddress($frmAddress);
      this.#handleShowOptionWardNewAddress($frmAddress);
    });
  }

  /**
   * JS ACCOUNT ADDRESS -- show option district
   */
  #handleShowOptionDistrictNewAddress (frmAddress) {
    const city_code = frmAddress.find('[name="address[city]"] option:selected').data('code');
    const objProvince = this.#handleGetObjProvince(city_code);
    let xhtmlOption = '';
    objProvince[0]['districts'].map(function (obj) {
      xhtmlOption += `<option value='${obj.code}' data-code='${obj.code}'>${obj.name}</option>`;
    });
    frmAddress.find('[name="address[province]"]').html(xhtmlOption);
  }

  /**
   * JS ACCOUNT ADDRESS -- show option ward
   */
  #handleShowOptionWardNewAddress (frmAddress) {
    const city_code = frmAddress.find('[name="address[city]"] option:selected').data('code');
    const province_code = frmAddress.find('[name="address[province]"] option:selected').data('code');
    const wardsList = this.#selectedAddressType[this.#getFormId(frmAddress)] === CustomAccountAddressesV2.#ADDRESS_SELECTION_TYPE.afterMerger ? this
      .#handleGetNewObjWard(city_code) : this.#handleGetObjWard(city_code, province_code);
    if (wardsList?.length) {
      let xhtmlOption = '';
      wardsList.map(function (obj) {
        const wardCode = obj.shippingProvider.code || obj.code
        const wardName = obj.shippingProvider.name || obj.name;
        if (wardCode && wardName) {
          xhtmlOption += `<option value='${wardCode}' data-code='${wardCode}'>${wardName}</option>`;
        }
      });
      frmAddress.find('[name="address[ward]"]').html(xhtmlOption);
    }
  }

  /**
   * JS get/set localStorage
   */
  #handleSession (type, key, val = null) {
    switch (type) {
      case CustomAccountAddressesV2.#SESSION_STORAGE_TYPE.set:
        sessionStorage.setItem(key, val);
        break;
      case CustomAccountAddressesV2.#SESSION_STORAGE_TYPE.get:
        return sessionStorage.getItem(key);
      default:
        break;
    }
  }

  /**
   * JS ACCOUNT ADDRESS -- handle select address type
   */
  #handleAddressTypeChange (formAddress) {
    if (formAddress) {
      const addressTypeSelectEl = formAddress.find('[name="address-type-select"]');
      const formId = this.#getFormId(formAddress) || CustomAccountAddressesV2.#DEFAULT_FORM_ADDRESS_ID;
      this.#handleToggleAddressType(formId, this.#selectedAddressType[formId], formAddress);

      // handle change
      addressTypeSelectEl.on('change', (event) => {
        const self = $(event.currentTarget);
        if (self.is(':checked')) {
          const typeSelected = self.val();
          // store selected address type by form id
          this.#selectedAddressType = {
            ...this.#selectedAddressType,
            [formId]: typeSelected
          };
          // toggle province el
          this.#handleToggleAddressType(formId, typeSelected, formAddress);
        }
      });

    }
  }

  /**
   * JS ACCOUNT ADDRESS -- handle toggle province el
   * @param {string} formId
   * @param {string} typeSelected
   * @param {jQuery} [formAddress]
   */
  #handleToggleAddressType (formId, typeSelected, formAddress) {
    if (formId) {
      const provinceEl = $(`#address-province-container-${formId}`);

      // toggle province el
      provinceEl.css('display', typeSelected === CustomAccountAddressesV2.#ADDRESS_SELECTION_TYPE.afterMerger ? 'none' : 'block');
      // re-render ward selection
      this.#handleShowOptionWardNewAddress(formAddress);
    }
  }

  /**
   * JS ACCOUNT ADDRESS -- setup form
   */
  #handleSetupForm ($frmAddress) {
    $frmAddress.find('[name="address[company]"]').parents('.form__control').hide();
    $frmAddress.find('[name="address[zip]"]').val('00000');
    $frmAddress.find('[name="address[zip]"]').parents('.form__control').hide();

    this.#handleShowDistrict($frmAddress);
    this.#handleShowCity($frmAddress);
    this.#handleShowWard($frmAddress);
    this.#handleAddressTypeChange($frmAddress);
  }

  /**
   * JS ACCOUNT ADDRESS -- active province
   */
  #handleActiveProvince (form) {
    const $eleFormData = form.find('.js-address-form-data');
    const cityName = $eleFormData.data('city');
    const $eleCity = form.find('[name="address[city]"]');
    $eleCity.val(cityName);
    this.#handleShowOptionDistrict($eleCity);

    const provinceValue = $eleFormData.data('province') || '';
    const [provinceCode, wardCode] = provinceValue.split('_');
    if (provinceCode) {
      const $eleProvince = form.find('[name="address[province]"]');
      $eleProvince.val(provinceCode);
      this.#handleShowOptionWard($eleProvince);
    }

    if (wardCode) {
      if (wardCode.startsWith('W') || !provinceCode) {
        $(form).find('input[name="address-type-select"]').trigger('click');
      }
      const $eleWard = form.find('[name="address[ward]"]');
      $eleWard.val(wardCode);
      $eleWard.data({
        default: wardCode,
        'default-value': wardCode
      });
    }
  }

  /**
   * JS CALL API GET DISTRICT
   */
  #getDistrict () {
    return new Promise((resolve, reject) => {
      $.get(CustomAccountAddressesV2.#PROVINCE_DISTRICT_CDN_URL, (data) => {
        resolve(data);
        this.#handleSession(
          CustomAccountAddressesV2.#SESSION_STORAGE_TYPE.set,
          CustomAccountAddressesV2.#PROVINCE_DISTRICT_SEV_V2_LOCAL_STORAGE_KEY,
          JSON.stringify(data)
        );
      });
    });
  }

  /**
   * JS CALL API GET DISTRICT
   */
  #getNewAddressData () {
    return new Promise((resolve, reject) => {
      $.get(CustomAccountAddressesV2.#NEW_PROVINCE_DISTRICT_CDN_URL, (data) => {
        resolve(data);
        this.#handleSession(
          CustomAccountAddressesV2.#SESSION_STORAGE_TYPE.set,
          CustomAccountAddressesV2.#NEW_PROVINCE_DISTRICT_SEV_LOCAL_STORAGE_KEY,
          JSON.stringify(data)
        );
      });
    });
  }

  /**
   * JS ACCOUNT ADDRESS -- filter get obj province
   */
  #handleGetObjProvince (city_code) {
    if (this.#provinceDistrictSev) {
      return this.#provinceDistrictSev.filter(function (e) {
        return e.code === city_code;
      });
    }
  }

  /**
   * JS ACCOUNT ADDRESS -- filter get obj ward
   */
  #handleGetObjWard (city_code, province_code) {
    let wardsList = [];
    if (this.#provinceDistrictSev) {
      const citiesList = this.#handleGetObjProvince(city_code);
      if (citiesList?.length) {
        const provincesList = citiesList[0]?.districts?.find((district) => district.code === province_code);
        if (provincesList?.wards?.length) wardsList = provincesList.wards;
      }
    }

    return wardsList;
  }

  /**
   * JS ACCOUNT ADDRESS -- filter get obj ward
   */
  #handleGetNewObjWard (city_code) {
    let wardsList = [];
    if (this.#newProvinceDistrictSev) {
      const selectedCityData = this.#newProvinceDistrictSev.find((city) => city.code === city_code);
      if (selectedCityData && selectedCityData.wards.length) {
        wardsList = selectedCityData.wards;
      }
    }

    return wardsList;
  }

  /**
   * JS ACCOUNT ADDRESS -- show city
   */
  #handleShowCity (frmAddress) {
    if (frmAddress.find('select[name="address[city]"]').length === 0 && this.#provinceDistrictSev) {
      let xhtmlOption = '';
      this.#provinceDistrictSev.map(function (ele) {
        xhtmlOption += `<option value='${ele.name}' data-code='${ele.code}'>${ele.name}</option>`;
      });
      let xhtml = `<div class='form__control' >
                      <label class='form__label float-label lb-select' for='address_city_${this.#getFormId(frmAddress)
      || CustomAccountAddressesV2.#DEFAULT_FORM_ADDRESS_ID}'>${CustomAccountAddressesV2.#CITY_LABEL}</label>
                      <div class='styled-select'>
                        <svg class='icon icon-dropdown-arrow'>
                          <use xlink:href='#icon-dropdown-arrow'></use>
                        </svg>
                        <select id='address_city_${this.#getFormId(frmAddress)}' name='address[city]' required='' data-validate='required'>
                          ${xhtmlOption}
                        </select>
                      </div>
                    </div>`;
      let eleTarget = frmAddress.find('[name="address[country]"]').parents('.form__control');
      $(xhtml).insertAfter(eleTarget);

      this.#handleChangeCity();
    }
  }

  /**
   * JS ACCOUNT ADDRESS -- show district
   */
  #handleShowDistrict (frmAddress) {
    if (frmAddress.find('select[name="address[province]"]').length === 0) {
      if (this.#provinceDistrictSev) {
        let xhtmlOption = '';
        let xhtml = `<div class='form__control' data-validate='required'>
                      <label class='form__label float-label lb-select' for='address_province_${this.#getFormId(frmAddress)
        || CustomAccountAddressesV2.#DEFAULT_FORM_ADDRESS_ID}'>${CustomAccountAddressesV2.#DISTRICT_LABEL}</label>
                      <div class='styled-select'>
                        <svg class='icon icon-dropdown-arrow'>
                          <use xlink:href='#icon-dropdown-arrow'></use>
                        </svg>
                        <select id='address_province_${this.#getFormId(frmAddress)}' name='address[province]' required=''>
                          ${xhtmlOption}
                        </select>
                      </div>
                    </div>`;
        let eleTarget = frmAddress.find('[name="address[country]"]').parents('.form__control');
        $(xhtml).insertAfter(eleTarget);
        this.#handleChangeProvince();
      }
    } else {
      frmAddress.find('select[name="address[province]"]').parents('.form__control').show();
      this.#handleChangeProvince();
    }
  }

  /**
   * JS ACCOUNT ADDRESS -- show ward
   */
  #handleShowWard (frmAddress) {
    if (frmAddress.find('select[name="address[ward]"]').length === 0) {
      if (this.#provinceDistrictSev) {
        let xhtmlOption = '';
        let xhtml = `<div class='form__control' data-validate='required'>
                      <label class='form__label float-label lb-select' for='address_ward_${this.#getFormId(frmAddress)
        || CustomAccountAddressesV2.#DEFAULT_FORM_ADDRESS_ID}'>${CustomAccountAddressesV2.#WARD_LABEL}</label>
                      <div class='styled-select'>
                        <svg class='icon icon-dropdown-arrow'>
                          <use xlink:href='#icon-dropdown-arrow'></use>
                        </svg>
                        <select id='address_ward_${this.#getFormId(frmAddress)}' name='address[ward]' required=''>
                          ${xhtmlOption}
                        </select>
                      </div>
                    </div>`;
        let eleTarget = frmAddress.find('[name="address[ward]"]').parents('.form__control');
        $(xhtml).insertAfter(eleTarget);
      }
    } else {
      frmAddress.find('select[name="address[ward]"]').parents('.form__control').show();
    }
  }

  /**
   * JS ACCOUNT ADDRESS -- on change select city
   */
  #handleChangeCity () {
    $('[name="address[city]"]').on('change', (event) => {
      this.#handleShowOptionDistrict($(event.currentTarget));
    });
  }

  /**
   * JS ACCOUNT ADDRESS -- on change select province
   */
  #handleChangeProvince () {
    $('[name="address[province]"]').on('change', (event) => {
      this.#handleShowOptionWard($(event.currentTarget));
    });
  }

  /**
   * JS ACCOUNT ADDRESS -- show option district
   */
  #handleShowOptionDistrict (ele) {
    const $frmAddress = $(ele).parents('form');
    const city_code = $frmAddress.find('[name="address[city]"] option:selected').data('code');
    const objProvince = this.#handleGetObjProvince(city_code);

    if (!objProvince.length) return;

    let xhtmlOption = '';
    objProvince[0]['districts'].map(function (obj) {
      xhtmlOption += `<option value='${obj.code}' data-code='${obj.code}'>${obj.name}</option>`;
    });
    $frmAddress.find('[name="address[province]"]').html(xhtmlOption);
    /** INFO: trigger change event to show ward */
    $('[name="address[province]"]').trigger('change');
  }

  /**
   * JS ACCOUNT ADDRESS -- show option ward
   */
  #handleShowOptionWard (ele) {
    const $frmAddress = $(ele).parents('form');
    const city_code = $frmAddress.find('[name="address[city]"] option:selected').data('code');
    const province_code = $frmAddress.find('[name="address[province]"] option:selected').data('code');
    const wardsList = this.#handleGetObjWard(city_code, province_code);

    if (!wardsList.length) return;

    let xhtmlOption = '';
    wardsList.map(function (obj) {
      xhtmlOption +=
        `<option value='${obj.shippingProvider.code}' data-code='${obj.shippingProvider.code}'>${obj.shippingProvider.name}</option>`;
    });
    $frmAddress.find('[name="address[ward]"]').html(xhtmlOption);
  }

  #getFormId (formEl) {
    return formEl.attr('data-id');
  }
}

$(document).ready(function () {
  const customAccountAddressesV2 = new CustomAccountAddressesV2();

  customAccountAddressesV2.initialize();
});

